/**
 * Whether the user may use PRO-only creation features.
 *
 * A user has pro access if their plan carries the `pro_features` flag, OR if
 * the library being worked on is unlocked by an active CPM campaign. Used to
 * gate the same set of options consistently across project creation, library
 * creation, and the community remix dialog.
 */
export function resolveProAccess({
  hasProFeatures,
  cpmUnlocked = false,
}: {
  hasProFeatures: boolean;
  cpmUnlocked?: boolean;
}): boolean {
  return hasProFeatures || cpmUnlocked;
}
